import React from "react";
import "./services.css";
import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        {/*  UI/UX */}
        <article className="service">
          <div className="services__head">
            <h3>UI/UX Design</h3>
          </div>

          <ul className="services__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>UX Design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>User Research & Analysis</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Customer Journey Mapping</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>UI and Interaction Design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>User Testing</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Mobile First Responsive Design Services</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Rapid and Interactive Protoptyping</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Customer Experience Consulting</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Design Thinking</p>
            </li>{" "}
          </ul>
        </article>

        {/* Web Development*/}
        <article className="service">
          <div className="services__head">
            <h3>Web Development</h3>
          </div>

          <ul className="services__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Websites</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Online Stores</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Web Applications</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Web Portals</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Content Management Systems</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Web Development Consulting</p>
            </li>
          </ul>
        </article>

        {/* Content Creation*/}
        <article className="service">
          <div className="services__head">
            <h3>SEO</h3>
          </div>

          <ul className="services__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Off-Page/Onn-Page SEO</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Keyword Research</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Technical SEO</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Competitor Analysis</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Google Ads</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  );
};

export default Services;
